/**
 * True when the portal runs on a loopback origin. Cloudflare Turnstile typically
 * cannot verify localhost, so registration should not show or require the widget.
 */
export function isLocalDevelopmentHost(): boolean {
  if (typeof globalThis === "undefined") {
    return false;
  }
  const loc = (globalThis as typeof globalThis & { location?: Location })
    .location;
  if (!loc?.hostname) {
    return false;
  }
  const hostname = loc.hostname.toLowerCase();
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]"
  );
}
